/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StartWorkspaceRecoveryRequest
 */
export interface StartWorkspaceRecoveryRequest {
    /**
     * 
     * @type {string}
     * @memberof StartWorkspaceRecoveryRequest
     */
    researchPurpose?: string;
    /**
     * 
     * @type {string}
     * @memberof StartWorkspaceRecoveryRequest
     */
    podId?: string;
}

/**
 * Check if a given object implements the StartWorkspaceRecoveryRequest interface.
 */
export function instanceOfStartWorkspaceRecoveryRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StartWorkspaceRecoveryRequestFromJSON(json: any): StartWorkspaceRecoveryRequest {
    return StartWorkspaceRecoveryRequestFromJSONTyped(json, false);
}

export function StartWorkspaceRecoveryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartWorkspaceRecoveryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'researchPurpose': !exists(json, 'researchPurpose') ? undefined : json['researchPurpose'],
        'podId': !exists(json, 'podId') ? undefined : json['podId'],
    };
}

export function StartWorkspaceRecoveryRequestToJSON(value?: StartWorkspaceRecoveryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'researchPurpose': value.researchPurpose,
        'podId': value.podId,
    };
}

